import { render, staticRenderFns } from "./TypeNotificationSelect.vue?vue&type=template&id=553341f8"
import script from "./TypeNotificationSelect.vue?vue&type=script&lang=js"
export * from "./TypeNotificationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports